import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "@tecma/i18n";
import { Button } from "@tecma/ds/button";
import { Icon } from "@tecma/ds/icon";
import { useHistory } from "react-router-dom";

import { LoginWrapper } from "components/LoginWrapper";

const ChangePasswordCompleted = observer(() => {
  const { t } = useTranslation();
  const history = useHistory();

  const goToLogin = () => {
    history.push("/login");
  };

  return (
    <LoginWrapper className='change-password-completed'>
      <LoginWrapper.Header>
        <Icon iconName='check-circle' filled size='extra-extra-large' />
        <span className='login-wrapper-header-title'>
          {t("businessplatform.changePasswordCompleted")}
        </span>
      </LoginWrapper.Header>
      <LoginWrapper.Content>
        <span className='login-wrapper-content-text'>
          {t("businessplatform.changePasswordCompleted.description")}
        </span>
        <Button onClick={goToLogin} fluid>
          {t("businessplatform.emailSent.goToLogin")}
        </Button>
      </LoginWrapper.Content>
    </LoginWrapper>
  );
});

export default ChangePasswordCompleted;
